import React from 'react'
import Header from "../components/Header";

export default function AboutMe() {
    return(
        <section className={"about-me"} id="about-me">
            <Header title={"About Me"}/>
            <p>As an accomplished frontend developer in India, React serves as my cornerstone
                for crafting impactful solutions.
                Open source contributions fuel my growth and community engagement,
                while my passion for learning keeps me at the forefront of technology.
                Adaptability defines my approach I thrive on mastering new tools
                and collaborating seamlessly within diverse teams. My commitment to React proficiency
                and active involvement in open source reflects my dedication to driving innovation
                in the ever-evolving landscape of software development.
            </p>

        </section>
    );
}
